module.exports = __webpack_public_path__ + "img/red-desert-decal-07.35d4c6d1.png";